import { S as getContext, Q as spread_props, R as bind_props, P as pop, N as push } from "./index.js";
import { c as classMap, S as SmuiElement } from "./SmuiElement.js";
import "clsx";
function Separator($$payload, $$props) {
  push();
  let nav = getContext("SMUI:list:item:nav");
  let context = getContext("SMUI:separator:context");
  let {
    use = [],
    class: className = "",
    padded = false,
    inset = false,
    insetLeading = false,
    insetTrailing = false,
    insetPadding = false,
    component: MyComponent = SmuiElement,
    tag = nav || context !== "list" ? "hr" : "li",
    children,
    $$slots,
    $$events,
    ...restProps
  } = $$props;
  let element;
  function getElement() {
    return element.getElement();
  }
  $$payload.out += `<!---->`;
  MyComponent($$payload, spread_props([
    {
      tag,
      use,
      class: classMap({
        [className]: true,
        "mdc-deprecated-list-divider": true,
        "mdc-deprecated-list-divider--padded": padded,
        "mdc-deprecated-list-divider--inset": inset,
        "mdc-deprecated-list-divider--inset-leading": insetLeading,
        "mdc-deprecated-list-divider--inset-trailing": insetTrailing,
        "mdc-deprecated-list-divider--inset-padding": insetPadding
      }),
      role: "separator"
    },
    restProps
  ]));
  $$payload.out += `<!---->`;
  bind_props($$props, { getElement });
  pop();
}
export {
  Separator as S
};
